import { FormattedMessage } from 'react-intl';

import styles from './CardFormFooter.module.scss';

const CardFormFooter = ({ isWebRoute }: { isWebRoute?: boolean }) => {
  return (
    <footer className={styles.footer}>
      <p>
        {isWebRoute ? (
          <FormattedMessage
            id="layout.footer.shortDisclaimer"
            description="Footer disclaimer"
            defaultMessage="
              You may turn off auto-renewal at any time by logging into your account.
              Some products are provided by third parties and your access to them is also subject to their terms.
            "
          />
        ) : (
          <FormattedMessage
            id="layout.footer.disclaimer"
            description="Footer disclaimer with policy links"
            defaultMessage="
            By clicking “Continue” and purchasing, you agree to our <termsLink>Terms of Service</termsLink> and <policyLink>Privacy Policy</policyLink>.
            To ensure uninterrupted access after your subscription ends,
            you agree that your subscription will renew for another term using the payment method provided.
            You may turn off auto-renewal at any time by logging into your account.
            Some products are provided by third parties and your access to them is also subject to their terms.
          "
            values={{
              termsLink: (chunks) => <a href="https://clearvpn.com/terms-of-service/">{chunks}</a>,
              policyLink: (chunks) => <a href="https://clearvpn.com/privacy-policy/">{chunks}</a>,
            }}
          />
        )}
      </p>
      <p>
        <FormattedMessage
          id="layout.footer.taxDisclaimer"
          defaultMessage="NOTE: Tax may apply , depending on your country of residence"
          description="Footer disclaimer about taxes"
        />
      </p>
    </footer>
  );
};

export default CardFormFooter;
